// extracted by mini-css-extract-plugin
export default {"audioList":"Previousaudios_audioList__Y9VMR","audioItem":"Previousaudios_audioItem__y23Ne"};